"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useZoomPosition(figureRef) {
    return (0, react_1.useCallback)(function (e) {
        if (!figureRef)
            return;
        var zoomer = figureRef.getBoundingClientRect();
        var x, y;
        var isTouchEvent = function (e) { return "touches" in e; };
        if (isTouchEvent(e)) {
            var touch = e.touches[0];
            x = ((touch.clientX - zoomer.x) / zoomer.width) * 100;
            y = ((touch.clientY - zoomer.y) / zoomer.height) * 100;
        }
        else {
            x = ((e.clientX - zoomer.x) / zoomer.width) * 100;
            y = ((e.clientY - zoomer.y) / zoomer.height) * 100;
        }
        return "".concat(Math.max(0, Math.min(x, 100)), "% ").concat(Math.max(0, Math.min(y, 100)), "%");
    }, [figureRef]);
}
exports.default = useZoomPosition;
